module.exports = __webpack_public_path__ + "media/images/orion_pictos/phone_help-349c111cedb84050b07c71b8977bcb2e.svg";